import styled from 'styled-components'
import { getHeaderTextStyles } from '../style'

const StyledHeaderText = styled.div`
    ${getHeaderTextStyles}
`

export default StyledHeaderText
